import { render, staticRenderFns } from "./DecksAndSlides.vue?vue&type=template&id=c761e5dc&scoped=true&"
import script from "./DecksAndSlides.js?vue&type=script&lang=js&"
export * from "./DecksAndSlides.js?vue&type=script&lang=js&"
import style0 from "./DecksAndSlides.vue?vue&type=style&index=0&id=c761e5dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c761e5dc",
  null
  
)

export default component.exports